export default "__VITE_ASSET__$e_rW06YrDsCDSlzhACLCg__"